<template>
    <div class="w-full flex flex-col p-8 text-ternary text-left">
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Event Type</div>
            <div class="w-3/4">{{ item.event_type }}</div>
        </div>
        <div v-if="item.event_type == 'Virtual Career Fair'" class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Participating Employers</div>
            <div class="w-3/4">{{ getEmployers }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Thumbnail</div>
            <div class="w-3/4">
                <img v-if="item.thumbnail" class="h-48 object-contain" :src="getSrcFile(item.thumbnail)" alt="">
                <span v-else>No thumbnail</span>
            </div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Title</div>
            <div class="w-3/4">{{ item.title }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Description</div>
            <div class="w-3/4">{{ item.description }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Content</div>
            <div
              class="w-3/4 event-view-content"
              v-html="formattedContent"
            ></div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Start Date</div>
            <div class="w-3/4">{{ getFormattedDateWithTimeAmPm(item.start_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">End Date</div>
            <div class="w-3/4">{{ getFormattedDateWithTimeAmPm(item.end_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Location</div>
            <div class="w-3/4">{{ item.location }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Entity</div>
            <div class="w-3/4">{{ item.entity.entity }}</div>
        </div>
        <div v-if="item.focal_point" class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Focal Point</div>
            <div class="w-3/4">{{ item.focal_point }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Registration Open</div>
            <div class="w-3/4">{{ item.registration_open ? 'Yes' : 'No' }}</div>
        </div>
        <div v-if="item.registration_open" class="flex flex-col mt-2">
            <div class="flex flex-row flex-wrap">
                <div class="w-1/4 font-bold">Open For(Students)</div>
                <div class="w-3/4">{{ item.open_for_students }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Open For(Entity)</div>
                <div class="w-3/4">{{ item.open_for_entity }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Registration Type</div>
                <div class="w-3/4">{{ item.registration_type }}</div>
            </div>
            <div v-if="item.registration_type == 'external'" class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Registration Link</div>
                <div class="w-3/4">{{ item.registration_link }}</div>
            </div>
            <div v-else class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Display Message</div>
                <div class="w-3/4">{{ item.display_message }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { formattedDateWithTimeAmPm } from "../../helpers/utils";
import { applyBidiDirectionToHtml } from "../../helpers/richTextDirection";
export default {
    name: "view-event",
    props: ["item"],
    computed: {
        getEmployers() {
            return this.item.event_employers.map(item => item.partner.en_company_name).join(', ');
        },
        formattedContent() {
            const content = this.item && this.item.content ? this.item.content : '';
            return applyBidiDirectionToHtml(content);
        },
    },
    methods: {
        getSrcFile(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        getFormattedDateWithTimeAmPm(date) {
            return formattedDateWithTimeAmPm(date);
        },
    },
}
</script>

<style scoped>
.event-view-content {
    max-width: 100%;
    line-height: 1.7;
    word-break: break-word;
}

.event-view-content :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 0.375rem;
    margin: 0.5rem 0;
}

.event-view-content :deep(.ql-align-center) {
    text-align: center;
}

.event-view-content :deep(.ql-align-right) {
    text-align: right;
}

.event-view-content :deep(.ql-align-justify) {
    text-align: justify;
}

.event-view-content :deep(.ql-direction-rtl) {
    direction: rtl;
    text-align: right;
}

.event-view-content :deep(.ql-direction-rtl.ql-align-center) {
    text-align: center;
}

.event-view-content :deep(.ql-direction-rtl.ql-align-left) {
    text-align: left;
}

.event-view-content :deep([dir="rtl"]) {
    direction: rtl;
    text-align: right;
    unicode-bidi: embed;
}

.event-view-content :deep([dir="ltr"]) {
    direction: ltr;
    text-align: left;
    unicode-bidi: embed;
}

.event-view-content :deep([dir="auto"]) {
    unicode-bidi: plaintext;
}

.event-view-content :deep(ul[dir="rtl"]),
.event-view-content :deep(ol[dir="rtl"]) {
    padding-left: 0;
    padding-right: 1.5em;
}

.event-view-content :deep(ul[dir="ltr"]),
.event-view-content :deep(ol[dir="ltr"]) {
    padding-right: 0;
    padding-left: 1.5em;
}
</style>
